export default {
  outerWrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexFlow: 'column'
  },
  mainContentWrapper: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
    mt: '1.5rem',
    flex: 1,
    minHeight: 0
  },
  topRow: {
    display: 'flex',
    columnGap: '1rem',
    alignItems: 'center',
    mb: '.5rem',
    p: '0 2rem'
  },
  addMultiDocWrapper: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center'
  },
  scanWrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexFlow: 'column'
  },
  bottomWrapper: {
    width: '100%',
    p: '1.1rem 0.8rem',
    display: 'flex',
    flexFlow: 'column',
    rowGap: '1.5rem',
    borderTop: '1px solid',
    borderColor: 'border.lighter',
    zIndex: 10,
    backgroundColor: 'bg.white'
  },
  verificationFieldWrapper: {
    flex: 1
    // display: 'flex',
    // flexFlow: 'column',
    // rowGap: '1rem'
  },
  captcha: {
    height: '100%',
    objectFit: 'contain',
    borderRadius: '6px'
  }
};
